import React, { useState, useEffect } from "react";
import { Modal, Input, Checkbox, Typography, Divider, Table, Space, Select } from "antd";
import { addRole, allModules, allRoles } from "../../functions/role";
import Cookies from "universal-cookie";
import { toast } from "react-toastify";
const ACTIONS = ["create", "read", "update", "delete", "approve"];

export default function AddRoleModal({ open, onClose }) {
  const [values, setValues] = useState({ name: "", permissions: [], saving: false, parentId: null, subRoleIds: [] });
  const token = new Cookies().get("token");
  const [MODULES, setModules] = useState([]);
  const [ROLES, setRoles] = useState([]);
  const fetchModules = async () => {
    try {
      const res = await allModules(token);
      console.log("res==>", res);
      if (res && Array.isArray(res.data)) {
        const uniqueModules = [...new Set(res.data)];
  
        setModules(uniqueModules);
        console.log("Unique modules:", uniqueModules);
      }
    } catch (err) {
      console.error("Failed to fetch modules", err);
    }
  };

  const fetchRoles = async () => {
    try {
      const res = await allRoles(token);
      const list = Array.isArray(res?.data?.roles) ? res.data.roles : [];
      setRoles(list);
    } catch (err) {
      console.error("Failed to fetch roles", err);
    }
  };

  useEffect(() => {
    fetchModules();
    fetchRoles();
  }, []);


  const toggle = (module, action) => {
    const updated = [...values.permissions];
    const mod = updated.find((p) => p.module === module);
    if (mod) {
      const actions = new Set(mod.actions);
      actions.has(action) ? actions.delete(action) : actions.add(action);
      mod.actions = [...actions];
    } else {
      updated.push({ module, actions: [action] });
    }
    setValues({ ...values, permissions: updated });
  };

  const checked = (module, action) =>
    values.permissions.find((p) => p.module === module)?.actions.includes(action);

  const handleSubmit = async () => {
    if (!values.name.trim()) return;
    setValues((v) => ({ ...v, saving: true }));
    try {
      const res = await addRole(token, {
        name: values.name.trim(),
        permissions: values.permissions,
        parent: values.parentId || null,
        subRole: (values.subRoleIds || []).filter((id) => id && id !== values.parentId),
      });
      setValues({ name: "", permissions: [], saving: false, parentId: null, subRoleIds: [] });
      onClose(true);
      toast.success(res.data.message);
    } catch (err) {
      toast.error(err.response?.data?.message || err.message);
      console.error(err);
    } finally {
      setValues((v) => ({ ...v, saving: false }));
    }
  };

  const columns = [
    {
      title: "Module",
      dataIndex: "module",
      render: (text) => <Typography.Text>{text}</Typography.Text>,
    },
    ...ACTIONS.map((action) => ({
      title: action,
      dataIndex: action,
      align: "center",
      render: (_, row) => (
        <Checkbox
          checked={checked(row.module, action)}
          onChange={() => toggle(row.module, action)}
        />
      ),
    })),
  ];

  const data = MODULES.map((m) => ({ key: m, module: m }));
  const filteredRoles = ROLES.filter((role) => role.name !== "admin" && role.name !== "Admin" && role.name !== "manager" && role.name !== "Manager");
  return (
    <Modal
      open={open}
      title="Add Role"
      onCancel={() => onClose(false)}
      onOk={handleSubmit}
      confirmLoading={values.saving}
      width={800}
    >
      <Space direction="vertical" style={{ width: "100%" }} size="middle">
        <div>
          <Typography.Text strong>Role Name</Typography.Text>
          <Input
            value={values.name}
            onChange={(e) => setValues({ ...values, name: e.target.value })}
            placeholder="Enter role name"
          />
        </div>

        <div>
          <Typography.Text strong>Parent Role (optional)</Typography.Text>
          <Select
            allowClear
            placeholder="Select parent role by name"
            value={values.parentId || undefined}
            onChange={(val) => setValues({ ...values, parentId: val || null, subRoleIds: (values.subRoleIds || []).filter((id) => id !== val) })}
            style={{ width: "100%" }}
            options={filteredRoles.map((r) => ({ label: r.name, value: r._id }))}
            showSearch
            optionFilterProp="label"
          />
        </div>

        <div>
          <Typography.Text strong>Sub-roles</Typography.Text>
          <Select
            mode="multiple"
            placeholder="Select sub-roles by name"
            value={values.subRoleIds}
            onChange={(vals) => setValues({ ...values, subRoleIds: (vals || []).filter((id) => id && id !== values.parentId) })}
            style={{ width: "100%" }}
            options={filteredRoles.map((r) => ({ label: r.name, value: r._id }))}
            showSearch
            optionFilterProp="label"
          />
        </div>

        <Divider />

        <Typography.Text strong>Permissions</Typography.Text>
        <Table
          columns={columns}
          dataSource={data}
          pagination={false}
          bordered
          size="small"
        />
      </Space>
    </Modal>
  );
}
